import { clientEnv } from '@/config/env/client';
import { AuthService as EltyAuthService } from '@davincihealthcare/auth-client';

let isInitialized = false;

const initialize = () => {
  if (!isInitialized) {
    isInitialized = true;
    EltyAuthService.initialize({
      baseUrl: clientEnv.NEXT_PUBLIC_AUTH_URL!,
      appId: clientEnv.NEXT_PUBLIC_AUTH_APP_ID!,
    });
  }
};

export const getEltyAuthToken = async () => {
  initialize();

  try {
    await EltyAuthService.default().waitForInitialization();

    const currentToken = EltyAuthService.default().currentToken();

    if (currentToken) {
      return currentToken;
    }

    return null;
  } catch (error) {
    console.error({ errorOnGetTokenFromEltyAuthService: JSON.stringify(error) });
  }
};

export const getLoggedPatientUsername = async () => {
  initialize();

  try {
    await EltyAuthService.default().waitForInitialization();

    const currentUser = EltyAuthService.default().currentUser;

    return currentUser?.authMethod?.type === 'username_password' ? currentUser.authMethod.username : null;
  } catch (error) {
    console.error({ errorOnGetPatientLoggedUsernameFromEltyAuthService: JSON.stringify(error) });
  }

  return null;
};
